import React from 'react';
import styles from './Button.module.css';

export enum ButtonTypes {
    PRIMARY = 'primary',
    SECONDARY = 'secondary'
}
interface IButtonProps {
    label: string;
    onClick?: () => void;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    className?: string;
    buttonTheme?: 'primary' | 'secondary' | 'tertiary' | 'quaternary';
    isLoading?: boolean;
    id?: string;
}

const Button: React.FC<IButtonProps> = ({
    label,
    onClick = () => {},
    type = 'button',
    className = '',
    buttonTheme = 'primary',
    id
}) => {
    const buttonStyles =
        buttonTheme === 'primary'
            ? styles.primaryButton
            : styles.secondaryButton;

    return (
        <button
            onClick={onClick}
            type={type}
            className={`${buttonStyles} ${className}`}
            id={id}
        >
            {label}
        </button>
    );
};

export default Button;
